import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'wsYesNo',
    standalone: false
})
export class WeissmanYesNoPipe implements PipeTransform {
    transform(value: boolean): string {
        return value ? 'Yes' : 'No';
    }
}

@Pipe({
    name: 'wsTrueFalse',
    standalone: false
})
export class WeissmanTrueFalsePipe implements PipeTransform {
    transform(value: boolean): string {
        return value ? 'True' : 'False';
    }
}
